import type { IAPI } from '../../apiResponse';
import { type IValidatedResponse, postRequest } from '../../httpClient';
import {
  type IRegenerateUserQueueV1Data,
  regenerateUserQueueV1ResponseSchema,
} from './regenerate-user-queue-v1-response';

export async function regenerateUserQueueV1Api(
  userId: string,
): Promise<IValidatedResponse<IAPI<IRegenerateUserQueueV1Data>>> {
  return postRequest<IAPI<IRegenerateUserQueueV1Data>>({
    path: `/sys/users/v1/${userId}/queue/regenerate`,
    schema: regenerateUserQueueV1ResponseSchema,
  });
}
